import { Component } from "react";
import { FaInstagram, FaTwitter, FaFacebookF } from "react-icons/fa";
import FooterProductsSection from "./footer_products_section";

export default class Footer extends Component {
    render() {
        return (
            <footer className="text-white pt-5" style={{ backgroundColor: "#193E6C" }}>
                <div className="container">
                    <div className="mb-5 col-md-3">
                        <img src="/Logo-white.webp" alt="BHEPL Logo" style={{ height: "60px" }} />
                    </div>
                    <div className="row justify-content-between">


                        <div className="col-12 col-md-3 mb-4">
                            <ul className="list-unstyled">

                                <li className="mb-2 w-100">
                                    <a href="#" className="text-white text-decoration-none d-flex align-items-center gap-2 fs-16">
                                        <span className="border d-flex align-items-center justify-content-center rounded-circle bg-social-icon" style={{ height: "30px", width: "30px" }}><FaInstagram /></span>
                                        <span className="hover-underline2 text-white-06">Instagram</span>
                                    </a>
                                </li>
                                <li className="mb-2">
                                    <a href="#" className="text-white text-decoration-none d-flex align-items-center gap-2 fs-16">
                                        <span className="border d-flex align-items-center justify-content-center rounded-circle bg-social-icon" style={{ height: "30px", width: "30px" }}><FaTwitter /></span>
                                        <span className="hover-underline2 text-white-06">Twitter</span>
                                    </a>
                                </li>
                                <li className="mb-2">
                                    <a href="#" className="text-white text-decoration-none d-flex align-items-center gap-2 fs-16">
                                        <span className="border d-flex align-items-center justify-content-center rounded-circle bg-social-icon" style={{ height: "30px", width: "30px" }}><FaFacebookF /></span>
                                        <span className="hover-underline2 text-white-06">Facebook</span>
                                    </a>
                                </li>
                            </ul>
                        </div>


                        <div className="col-6 col-md-2 mb-4">
                            <h6 className="fs-20">Pages</h6>
                            <ul className="list-unstyled">
                                <li className="mb-2"><a href="/about" className="text-white text-decoration-none hover-underline2">Our Company</a></li>
                                <li className="mb-2"><a href="/innovation" className="text-white text-decoration-none hover-underline2">Innovation</a></li>
                                <li className="mb-2"><a href="/solutions" className="text-white text-decoration-none hover-underline2">Solutions</a></li>
                                <li className="mb-2"><a href="/case-studies" className="text-white text-decoration-none hover-underline2">Case Studies</a></li>
                                <li className="mb-2"><a href="/careers" className="text-white text-decoration-none hover-underline2">Careers</a></li>
                                <li className="mb-2"><a href="/contact" className="text-white text-decoration-none hover-underline2">Contact</a></li>
                            </ul>
                        </div>

                        <FooterProductsSection />

                        <div className="col-6 col-md-2 mb-4">
                            <h6 className="fs-20">Other Pages</h6>
                            <ul className="list-unstyled">
                                <li><a href="/privacy" className="text-white text-decoration-none hover-underline2">Privacy Policy</a></li>
                                {/* <li><a href="#" className="text-white text-decoration-none hover-underline2 mt-2">Terms</a></li> */}
                            </ul>
                        </div>

                    </div>

                    <hr style={{ borderColor: "rgba(255,255,255,1)" }} />

                    <div className="text-center pb-3 mt-4">
                        <label className="fs-16 text-white-06">Copyright © 2024 BHEPL. All Rights Reserved</label>
                    </div>
                </div>
            </footer>
        );
    }
}
